/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Save_ConfirmInputs */



/**
* | output |
* | --- |
* | "Save" |
*
* @param {Video_Export_Export_Preset_Save_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_save_confirm = /** @type {((inputs?: Video_Export_Export_Preset_Save_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Save_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ahorrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节省")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बचाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar")
	return /** @type {LocalizedString} */ ("Save")
});